<template>
	<div
		class="content-component"
		v-html="data"
	/>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
	props: {
		data: {
			type: String,
			required: true,
		},
	},
});
</script>

<style scoped lang="scss">
.content-component {
	:deep() {
		h5 {
			margin-top: 1.5rem;
			font-weight: 600;
		}

		table {
			margin: 20px 0;
			text-align: left;

			th,
			td {
				padding: 0 4px;
			}

			thead {
				th {
					padding-bottom: 10px;
				}
			}
		}
	}
}
</style>
